import { useState, useEffect } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import api from '../../../../Axios.js';
import { toast } from 'react-toastify';

const Declaration = () => {
    const [data, setData] = useState('');

    const fetchDeclaration = async () => {
        try {
            const response = await api.get('/declaration');
            setData(response.data.data.declaration || '');
        } catch (err) {
            // toast.error('Failed to fetch declaration. Please try again.', {
            //     position: "top-right",
            //     autoClose: 3000,
            // });
        }
    };

    useEffect(() => {
        fetchDeclaration();
    }, []);

    const updateDeclaration = async () => {
        try {
            const payload = { declaration: data };
            const result = await api.post('/declaration', payload);
            toast.success(result.data.message || 'Declaration updated successfully!');
        } catch (err) {
            toast.error(err.response?.data?.error || 'An error occurred. Please try again.', {
                position: "top-right",
                autoClose: 3000,
            });
        };
    };


    return (
        <div className="row">
            <div className="col-lg-12">
                <h2>Declaration Setting</h2>
                <p>
                    This declaration will appear to the users while they are acknowledging the assigned asset.
                </p>
            </div>

            <div className="col-lg-12 text-center">
                <CKEditor
                    editor={ClassicEditor}
                    data={data}
                    onChange={(event, editor) => {
                        const data = editor.getData();
                        setData(data);
                    }}
                />
                <button className='btn btn-success mt-2' onClick={updateDeclaration}>Save</button>
            </div>

        </div>
    );
};

export default Declaration;
